// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import React from 'react'
import { Row, Select, Typography, DatePicker, Button } from 'antd'
import { connect } from 'react-redux'
import { DOWNLOAD_TASK_NAME, TASK_TYPE_SECTIONS } from '../../constants'
import TimePicker from '../time-picker'

const Option = Select.Option

class CreateDownloadRequest extends React.Component {
  handleDatePickerChange (values) {
    let startDate, endDate
    if (values === null) {
      startDate = null
      endDate = null
    } else {
      startDate = values[0]
      endDate = values[1]
    }
    const { updateEditingPreTask } = this.props
    updateEditingPreTask({
      startDate,
      endDate
    })
  }

  handleTimePickerChange (times) {
    const startTime = times ? times[0] : null
    const endTime = times ? times[1] : null
    const { updateEditingPreTask } = this.props
    updateEditingPreTask({
      startTime,
      endTime
    })
  }

  handleTaskTypeChange (jobType) {
    const { changeTaskType } = this.props
    changeTaskType(jobType)
  }

  handleAddPreTask = () => {
    const { editingPreTask, addToPreTaskList } = this.props
    addToPreTaskList(editingPreTask)
  }

  render () {
    const { editingPreTask, clearEditingPreTask, mode } = this.props
    const { jobType, startDate, endDate, startTime, endTime, isAddButtonShow } = editingPreTask
    return (
      <div className='download-task-form'>
        <Typography.Text type='secondary'>Upload type</Typography.Text>

        <Select
          value={jobType}
          onChange={this.handleTaskTypeChange.bind(this)}
          placeholder='Select'
          style={{ width: '100%', marginBottom: 12 }}
          disabled={true}
        >
          {TASK_TYPE_SECTIONS.map((taskType, k) => (
            <Option key={k} value={taskType}>
              {DOWNLOAD_TASK_NAME[taskType]}
            </Option>
          ))}
        </Select>
        <Typography.Text type='secondary'>Select Date</Typography.Text>

        <Row>
          <DatePicker.RangePicker
            onChange={this.handleDatePickerChange.bind(this)}
            value={[startDate, endDate]}
            style={{ width: '100%', marginBottom: 12 }}
          />
          <Typography.Text type='secondary'>Select Time</Typography.Text>
          <TimePicker.RangePicker
            onChange={this.handleTimePickerChange.bind(this)}
            value={[startTime, endTime]}
            use12Hours
            format='hh:mm A'
            minuteStep={5}
            style={{ width: '100%', marginBottom: 12 }}
          />
          {!!isAddButtonShow && (
            <Row style={{ width: '100%', marginTop: 14 }}>
              <Button type='primary' size='small' onClick={this.handleAddPreTask}>
                Add a Job
              </Button>
              <Button style={{ marginLeft: 12 }} type='ghost' size='small' onClick={() => clearEditingPreTask()}>
                Clear
              </Button>
            </Row>
          )}
        </Row>
      </div>
    )
  }
}

const mapState2Props = ({ download, loading }) => ({
  ...download,
  loading: loading.models.download
})
const mapDispatch2Props = ({ download, road, cameraFinder, gpsTrace }) => ({
  ...download
})
export default connect(mapState2Props, mapDispatch2Props)(CreateDownloadRequest)
